import type { Company } from '@/entities/company'
import { requisiteError, useEditCompany } from '@/features/edit-company'
import { writeThroughErrorText } from '@/shared/api'
import { InlineText } from '@/shared/ui/inline-edit'
import { toast } from '@/shared/ui/toast'

const REQ_LABELS: Array<[keyof Company['requisites'], string]> = [
  ['legal_name', 'Юридическое название'],
  ['inn', 'ИНН'],
  ['kpp', 'КПП'],
  ['ogrn', 'ОГРН'],
  ['legal_address', 'Юридический адрес'],
  ['bank_details', 'Банковские реквизиты'],
]

// Грид реквизитов с inline-правкой (клик по значению → input, PATCH шлёт одно
// поле — остальные бэк не трогает). Реюз: карточка компании (сотрудник) и таб
// «Реквизиты» хаба заказчика (customer-admin — бэк разрешает один requisites).
// Контакты и ссылки — самостоятельные разделы, реквизитов не касаются.
export function RequisitesGrid({ company }: { company: Company }) {
  const edit = useEditCompany(company.id)

  function saveRequisite(key: keyof Company['requisites'], value: string) {
    const invalid = requisiteError(key, value)
    if (invalid) {
      toast.error(invalid)
      return
    }
    edit.mutate(
      { requisites: { [key]: value } },
      {
        onError: (e) => toast.error(writeThroughErrorText(e) ?? 'Не удалось сохранить'),
      },
    )
  }

  return (
    <dl className="grid grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2">
      {REQ_LABELS.map(([key, label]) => (
        <div key={key} className="flex flex-col gap-0.5">
          <dt className="text-text-tertiary text-xs">{label}</dt>
          <dd className="text-sm text-text-primary">
            <InlineText
              value={company.requisites[key] ?? ''}
              ariaLabel={label}
              placeholder="Не заполнено"
              saving={edit.isPending}
              onSave={(v) => saveRequisite(key, v)}
            />
          </dd>
        </div>
      ))}
    </dl>
  )
}
